import type { ColorPalette } from '@chakra-ui/react';
import { Status as ChakraStatus } from '@chakra-ui/react';
import * as React from 'react';

export interface StatusProps extends ChakraStatus.RootProps {
	value?: StatusValue
}

type StatusValue = 'error' | 'info' | 'success' | 'warning';

const statusMap: Record<StatusValue, ColorPalette> = {
	error:   'red',
	info:    'blue',
	success: 'green',
	warning: 'orange',
};

export const Status = React.forwardRef<HTMLDivElement, StatusProps>(function Status(props, ref) {
	const { children, value = 'info', ...rest } = props;
	const colorPalette = rest.colorPalette ?? statusMap[value];

	return (
		<ChakraStatus.Root ref={ref} {...rest} colorPalette={colorPalette}>
			<ChakraStatus.Indicator />
			{children}
		</ChakraStatus.Root>
	);
});
